import React, { Component } from "react";
import { Flex } from "../../styles/GlobalStyle.js";
import {
  ListTitle,
  ListHeaderTitle,
  ListSubTitle,
  TopPadding,
  CircleButton,
  Container,
  NumberStyle,
  SmallTitle,
  FlexContainer,
  NavBarLink,
  TitlePrice,
  TitleAlert,
  PairButton,
} from "./style/ProductDetailStyle.js";
import Selector from "../../components/Selector";
import AddCircle from "@material-ui/icons/AddCircle";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import TopBar from "../../components/navbar/TopBar";
import HeaderImage from "../../components/HeaderImage";
import Property from "./../../model/property";
import storeFunction from "../../utils/storeFunction";
import FillRequiredModal from "../../components/modal/FillRequiredModal";
import { withTranslation } from "react-i18next";
import {
  isEmpty,
  filter,
  sumBy,
  forEach,
  get,
  find,
  isUndefined,
  replace,
  isNull,
  map,
} from "lodash";
import LoadingIcon from "../../components/LoadingIcon";
import placeholderRectangle from "../../assets/placeholder-rectangle.png";
import HourlyProduct from "../../components/HourlyProduct";
import TokenService from "../../backend/TokenService";
import InventoryService from "../../backend/InventoryService";
import FixedInventoryService from "../../backend/FixedInventoryService";
import Availability from "../../components/Availability";
import moment from "moment";

const CategoriesService = require("../../backend/CategoriesService");
const StoreListService = require("../../backend/StoreListService");

async function getMainData(productUid, language) {
  const getPropertyResponse = await CategoriesService.getCategoryByProduct(
    productUid,
    language
  );
  const property = getPropertyResponse.data;
  const response = await StoreListService.getPreset(property.uid);
  const presets = response.data;

  Property.setPreset(property.uid, presets);
  setHomeGlobalBackgroundColor(presets);
  return property;
}

function setHomeGlobalBackgroundColor(presets) {
  if (presets) {
    if (!isEmpty(presets.app_webstore_favicon_url)) {
      const favicon = document.getElementById("favicon");
      if (favicon) favicon.href = presets.app_webstore_favicon_url;
      const appleFavicon = document.getElementById("apple-favicon");
      if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
    }
    const desktopContainer = document.getElementById("desktop-container");
    if (desktopContainer) {
      if (!isEmpty(presets.app_home_webapp_desktop_bg)) {
        desktopContainer.style.backgroundColor =
          presets.app_home_webapp_desktop_bg;
      }
    }
    const root = document.getElementById("root");
    const tabletContainer = document.getElementById("tablet-container");
    const wrapper = tabletContainer ? tabletContainer : root;

    if (wrapper) {
      if (!isEmpty(presets.app_home_global_background_color)) {
        wrapper.style.backgroundColor =
          presets.app_home_global_background_color;
      }
    }
  }
}

class ProductDetail extends Component {
  constructor(props) {
    super(props);

    let { productId } = this.props.match.params;
    let product = Property.getProduct(productId);

    this.state = {
      counter: 1,
      addedProduct: {},
      product: product,
      insideTimeBased: {
        insideTimeBased: true,
        displayText: "",
      },
      price: 0.0,
      title: "",
      subTitle: "",
      addedPrice: {},
      requiredField: false,
      checkValidation: false,
      displayOnly: false,
      displayPickProductPrice: false,
      pairedUser: false,
      unpairedAvailable: false,
      preset: {},
      arraySelector: [],
      inventory: {},
      inventoryDates: [],
      dailyProduct: null,
      enableHourlyPopup: false,
      enableAvailabilityPopup: false,
      configuration: {},
      fixedInventory: null,
      fixedInventorySelection: false,
      soldOut: false,
      loading: true,
      fulfillmentTypeName: "",
    };
  }

  handleClickPairButton() {
    if (!isNull(Property.getSignIn()) && Property.getSignIn()) {
      window.ReactNativeWebView.postMessage("navigation_pair_room");
    } else {
      window.ReactNativeWebView.postMessage("navigation_login_options");
    }
  }

  plusMinus(data) {
    const { fixedInventorySelection } = this.state;
    let counter = this.state.counter;
    if (data === "plus") {
      let maxQuantity = this.maxQuantityOrder();
      if (
        !fixedInventorySelection ||
        (fixedInventorySelection && maxQuantity > counter)
      ) {
        counter += 1;
      }
    } else if (data === "minus") {
      if (this.state.counter >= 1) {
        counter -= 1;
      }
    }

    this.setState({
      counter: counter,
    });
  }

  navbarClicked(e) {
    let itemSelection = "";
    let validateDataInput = true;
    let priceOptions = [];
    let selectionOptions = [];
    let itemAutoReminder = [];
    const selectors = this.state.arraySelector;

    this.setState({
      checkValidation: true,
    });

    for (let i = 0; i < selectors.length; i++) {
      const selectionType = selectors[i].selection_type;
      const shouldSetValueAsText =
        selectionType === "pick_date" ||
        selectionType === "pick_time" ||
        selectionType === "pick_time_relative" ||
        selectionType === "pick_date_and_time" ||
        selectionType === "pick_date_and_static_time" ||
        selectionType === "pick_date_spa_booker" ||
        selectionType === "pick_number" ||
        selectionType === "text_input" ||
        selectionType === "signature";

      if (shouldSetValueAsText) {
        selectionOptions.push({
          id: selectors[i].id,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          autoReminder: selectors[i].auto_reminder || false,
          values: [{ value: selectors[i].values || "-" }],
        });
      } else if (["pick_product_price"].includes(selectionType)) {
        selectionOptions.push({
          id: selectors[i].id,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, ({ value }) => value > 0),
            (data) => ({
              ...data,
              value: `${data.name} x ${data.value} (${
                data.value * data.price
              })`,
              counter: data.value,
            })
          ),
        });
      } else if (
        selectionType === "pick_one" ||
        selectionType === "pick_multiple"
      ) {
        selectionOptions.push({
          id: selectors[i].id,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, { select: true }),
            (data) => ({
              ...data,
              value: data.name,
            })
          ),
        });
      } else if (
        selectionType === "pick_one_price" ||
        selectionType === "pick_multiple_price"
      ) {
        selectionOptions.push({
          id: selectors[i].id,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, { select: true }),
            (data) => ({
              ...data,
              value: `${data.name} ${data.price}`,
            })
          ),
        });
      } else if (selectionType === "pick_dropdown") {
        selectionOptions.push({
          id: selectors[i].id,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: map(
            filter(selectors[i].values, { select: true }),
            (data) => ({ ...data, value: `${get(data, "name", "")}` })
          ),
        });
      } else {
        selectionOptions.push({
          id: selectors[i].id,
          type: selectionType,
          index: i,
          title: selectors[i].title,
          values: filter(selectors[i].values, { select: true }),
        });
      }

      if (shouldSetValueAsText) {
        itemSelection +=
          selectors[i].title + ": " + (selectors[i].values || "\n- ");
        if (selectors[i].force_input) {
          if (!selectors[i].values) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (selectionType === "pick_one") {
        let prices = [];
        itemSelection += selectors[i].title + ": ";
        let pickOneValid = false;
        for (let l = 0; l < selectors[i].values.length; l++) {
          if (selectors[i].values[l].select) {
            if (selectionType === "pick_one") {
              itemSelection += selectors[i].values[l].name + "\n";
            }
          }

          if (selectors[i].force_input) {
            if (selectors[i].values[l].select === true) {
              pickOneValid = true;
              break;
            }
          }
        }
        if (!isEmpty(prices)) {
          priceOptions = [
            ...priceOptions,
            {
              type: selectionType,
              prices: [...prices],
            },
          ];
        }
        if (selectors[i].force_input && !pickOneValid) {
          validateDataInput = false;
          break;
        }
      }

      if (
        selectionType === "pick_multiple" ||
        selectionType === "pick_multiple_price" ||
        selectionType === "pick_one_price"
      ) {
        let prices = [];
        itemSelection += selectors[i].title + ": ";
        let pickMultipleValid = false;

        for (let k = 0; k < selectors[i].values.length; k++) {
          if (selectors[i].values[k].select) {
            if (
              selectionType === "pick_multiple_price" ||
              selectionType === "pick_one_price"
            ) {
              itemSelection +=
                selectors[i].values[k].name +
                " (+" +
                selectors[i].values[k].price +
                ")";
              prices = [...prices, { amount: selectors[i].values[k].price }];
            }

            if (selectionType === "pick_multiple") {
              itemSelection += selectors[i].values[k].name + ", ";
            }
          }
        }

        if (!isEmpty(prices)) {
          priceOptions = [
            ...priceOptions,
            {
              type: selectionType,
              prices: [...prices],
            },
          ];
        }

        for (let k = 0; k < selectors[i].values.length; k++) {
          if (selectors[i].force_input) {
            if (selectors[i].values[k].select === true) {
              pickMultipleValid = true;
              break;
            }
          }
        }

        itemSelection += "\n";
        if (selectors[i].force_input && !pickMultipleValid) {
          validateDataInput = false;
          break;
        }
      }

      if (["pick_product_price"].includes(selectionType)) {
        let prices = [];
        const itemSelected = [];
        itemSelection += selectors[i].title + ": ";

        forEach(selectors[i].values, (data) => {
          if (data.value > 0) {
            itemSelected.push(
              `${data.name}x${data.value} (${data.value * data.price})`
            );
            prices.push({ amount: data.price, quantity: data.value });
          }
        });
        itemSelection += itemSelected.join("\n");

        if (!isEmpty(prices)) {
          priceOptions = [
            ...priceOptions,
            { type: selectionType, prices: [...prices] },
          ];
        }
      }

      if (selectionType === "pick_dropdown") {
        const dataSelected = find(selectors[i].values, { select: true });
        itemSelection += `${selectors[i].title}: ${get(
          dataSelected,
          "name",
          ""
        )}\n`;
        if (selectors[i].force_input && isUndefined(dataSelected)) {
          validateDataInput = false;
          break;
        }
      }

      if (
        ["pick_date_and_time", "pick_time"].includes(selectionType) &&
        selectors[i].auto_reminder
      ) {
        let text;

        if (
          Array.isArray(selectors[i].values) &&
          selectors[i].values.length > 0 &&
          selectors[i].values[0].value
        ) {
          text = selectors[i].title + ": " + selectors[i].values[0].value;
        } else {
          text = selectors[i].title + ": " + selectors[i].values;
        }
        const dataAutoReminder = {
          title: text,
          timestamp: selectors[i].timestamp,
        };
        itemAutoReminder.push(dataAutoReminder);
      }

      if (["fixed_inventory_selection"].includes(selectionType)) {
        let text;
        if (
          Array.isArray(selectors[i].values) &&
          selectors[i].values.length > 0 &&
          selectors[i].values[0].date
        ) {
          text =
            selectors[i].title +
            ": " +
            moment(selectors[i].values[0].date).format("YYYY-MM-DD");
        } else {
          text = selectors[i].title + ": " + selectors[i].values;
        }
        itemSelection += text;
      }

      if (["hourly_product"].includes(selectionType)) {
        let text;
        if (
          Array.isArray(selectors[i].values) &&
          selectors[i].values.length > 0 &&
          selectors[i].values[0].date
        ) {
          const selectorValue = selectors[i].values[0];
          text = `${selectors[i].title}: ${moment(selectorValue.date).format(
            "ddd, MMM DD"
          )} ${selectorValue.start_time} - ${selectorValue.end_time}`;
        } else {
          text = selectors[i].title + ": " + selectors[i].values;
        }
        itemSelection += text;
      }
    }

    const productItem = Property.getProductDetailData();
    const uid = productItem ? productItem.uid : "";
    const itemPrice = find(get(productItem, "options", []), {
      selection_type: "pick_product_price",
    })
      ? 0
      : get(productItem, "price", 0);
    const itemName = productItem ? productItem.title : "";
    const subTitle = productItem ? productItem.subtitle : "";
    const unpairedAvailable = productItem
      ? productItem.unpaired_available
      : false;
    let priceProduct = itemPrice;
    for (const i in this.state.addedPrice) {
      priceProduct = priceProduct + this.state.addedPrice[i];
    }
    const { categoryId } = this.props.match.params;
    const category = Property.getCategory(categoryId);
    const payload = {
      uid,
      item_quantity: this.state.counter,
      item_quantity_list: this.state.counter,
      item_selection: itemSelection,
      pos_item_id: 0,
      item_price: priceProduct,
      item_name: itemName,
      item_subtitle: subTitle,
      unpaired_available: unpairedAvailable,
      price_options: [...priceOptions],
      selection_options: selectionOptions,
      category_unpaired_available: category.unpaired_available,
      updatedAt: productItem.updatedAt,
    };
    if (itemAutoReminder.length > 0) {
      payload["auto_reminder_base_time"] = itemAutoReminder;
    }

    if (!validateDataInput) {
      this.setState({ requiredField: true });
      e.preventDefault();
    } else {
      Property.setCartItem(payload);
      Property.popPreviousTitle();

      const productUrl = `/categories/${categoryId}/products`;
      this.props.history.push(productUrl);
    }

    // TODO: Use useContext from React https://medium.com/dailyjs/comparison-of-state-management-solutions-for-react-2161a0b4af7b
    // StoreManager.basketItem.push(payload)
  }

  handleValidation() {
    let validateDataInput = true;
    const selectors = this.state.arraySelector;

    this.setState({
      checkValidation: true,
    });
    for (let i = 0; i < selectors.length; i++) {
      const selectionType = selectors[i].selection_type;
      const shouldSetValueAsText =
        selectionType === "pick_date" ||
        selectionType === "pick_time" ||
        selectionType === "pick_time_relative" ||
        selectionType === "pick_date_and_time" ||
        selectionType === "pick_date_and_static_time" ||
        selectionType === "pick_date_spa_booker" ||
        selectionType === "pick_number" ||
        selectionType === "text_input";

      if (shouldSetValueAsText) {
        if (selectors[i].force_input) {
          if (!selectors[i].values) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (selectionType === "pick_one" || selectionType === "pick_one_price") {
        let pickOneValid = false;
        if (selectors[i].force_input) {
          for (let l = 0; l < selectors[i].values.length; l++) {
            if (selectors[i].values[l].select === true) {
              pickOneValid = true;
              break;
            }
          }
          if (!pickOneValid) {
            validateDataInput = false;
            break;
          }
        }
      }

      if (
        selectionType === "pick_multiple" ||
        selectionType === "pick_multiple_price"
      ) {
        let pickMultipleValid = false;
        for (let k = 0; k < selectors[i].values.length; k++) {
          if (selectors[i].force_input) {
            if (selectors[i].values[k].select === true) {
              pickMultipleValid = true;
              break;
            }
          }
        }

        if (selectors[i].force_input && !pickMultipleValid) {
          validateDataInput = false;
          break;
        }
      }

      if (selectionType === "pick_dropdown") {
        const dataSelected = find(selectors[i].values, { select: true });
        if (selectors[i].force_input && isUndefined(dataSelected)) {
          validateDataInput = false;
          break;
        }
      }
    }
    return validateDataInput;
  }

  bottomBar(productUrl, bottomText) {
    const {
      displayOnly,
      counter,
      preset,
      configuration,
      fixedInventorySelection,
      soldOut,
    } = this.state;
    const usePickProductPrice = find(this.state.arraySelector, {
      selection_type: "pick_product_price",
    });
    const enableInventoryManagement = get(
      configuration,
      "preset_config.enable_inventory_management",
      false
    );
    const hasHourlyProduct =
      find(this.state.arraySelector, { selection_type: "hourly_product" }) &&
      enableInventoryManagement;
    const hasFixedInventorySelection =
      fixedInventorySelection && enableInventoryManagement;

    if (displayOnly) {
      return this.renderPreviousMenu(productUrl);
    }
    if (!this.state.insideTimeBased.insideTimeBased) {
      return this.renderPreviousMenu(productUrl);
    }

    if (
      !isNull(Property.getPairGuest()) &&
      !Property.getPairGuest() &&
      !Property.getProductAvailableForUnpair()
    ) {
      return this.renderPreviousMenu(productUrl);
    }

    if (fixedInventorySelection && soldOut) {
      return this.renderPreviousMenu(productUrl);
    } else if (usePickProductPrice && counter === 0) {
      return (
        <NavBarLink
          id="bottom-bar-link"
          app_home_color_primary={preset.app_home_color_primary}>
          <FlexContainer>
            <SmallTitle
              className={"textStyle"}
              app_home_text_top_nav={preset.text_color}>
              {this.props.t("SELECT_OPTION")}
            </SmallTitle>
          </FlexContainer>
        </NavBarLink>
      );
    } else if (counter > 0) {
      return (
        <NavBarLink
          id="bottom-bar-link"
          onClick={(e) => {
            if (this.handleValidation() && hasHourlyProduct) {
              this.hourlyProductPopup(e);
            } else if (hasFixedInventorySelection) {
              this.handleFixedInventoryAvailabilitySelect(e);
            } else {
              this.navbarClicked(e);
            }
          }}
          app_home_color_primary={preset.app_home_color_primary}
          className="cursor-pointer">
          <FlexContainer>
            <SmallTitle
              className={"textStyle"}
              app_home_text_top_nav={preset.text_color}>
              {bottomText}
            </SmallTitle>
          </FlexContainer>
        </NavBarLink>
      );
    } else {
      return this.renderPreviousMenu(productUrl);
    }
  }

  hourlyProductPopup = (e) => {
    e.preventDefault();
    this.setState({
      enableHourlyPopup: true,
    });
  };
  hourlyProductClosePopup = () => {
    this.setState({
      enableHourlyPopup: false,
    });
  };

  handleClick(e) {
    e.preventDefault();
    Property.popPreviousTitle();
    this.props.history.goBack();
  }

  renderPreviousMenu() {
    const previousText = this.props.t("PREVIOUS_MENU");
    const { preset } = this.state;
    return (
      <NavBarLink
        id="bottom-bar-link"
        onClick={this.handleClick.bind(this)}
        app_home_color_primary={preset.app_home_color_primary}>
        <FlexContainer>
          <SmallTitle
            className={"textStyle"}
            app_home_text_top_nav={preset.text_color}>
            {previousText}
          </SmallTitle>
        </FlexContainer>
      </NavBarLink>
    );
  }

  setDisplay() {
    const productItem = this.state.product;
    const title = productItem ? productItem.title : "";
    const subTitle = productItem ? productItem.subtitle : "";
    const selector = productItem ? productItem.options : [];
    const { categoryId } = this.props.match.params;
    const category = Property.getCategory(categoryId);
    const displayOnly =
      storeFunction.isAvailable(category) ||
      storeFunction.isAvailable(Property.getData().store) ||
      storeFunction.isAvailable(productItem);
    const dataParent = Property.getData();

    let pairedUser = Property.getPairingUserStatus();
    let price = get(productItem, "price", 0.0);
    let parentNode = {};
    let displayPickProductPrice = false;

    if (dataParent && dataParent.store) {
      parentNode = dataParent.store;
    } else if (dataParent && dataParent.category) {
      parentNode = category;
    } else {
      parentNode = dataParent;
    }

    let insideTimeBased = storeFunction.checkTimeAvailability(
      parentNode,
      productItem
    );
    if (insideTimeBased.insideTimeBased && parentNode.type === "Store") {
      insideTimeBased = storeFunction.checkTimeAvailability(
        category,
        productItem
      );
    }
    let arraySelector = [];

    for (let i = 0; i < selector.length; i++) {
      const data = selector[i];
      let newData = { ...data };
      for (const key in data) {
        if (!data[key] && data[key] !== 0) {
          continue;
        }

        if (key === "values") {
          // data.values && data.values.length > 0
          const newValues = [];
          for (let z = 0; z < data.values.length; z++) {
            // @ts-ignore
            let newData2 = {};
            const node = data.values[z];
            for (const key2 in node) {
              if (!node[key2] && node[key2] !== 0) {
                continue;
              }
              newData2[key2] = node[key2];
            }
            if (
              newData.selection_type === "pick_one" ||
              newData.selection_type === "pick_one_price"
            ) {
              if (z.toString() === data.default) {
                newData2.select = true;
              } else {
                newData2.select = false;
              }
            } else {
              if (newData2.default === "true") {
                newData2.select = true;
              } else {
                newData2.select = false;
              }
            }

            if (newData.selection_type === "pick_multiple_price") {
              newData2.select = !!newData2.default;
            }

            if (newData.selection_type === "pick_multiple") {
              newData2.select = !!newData2.default;
            }

            if (newData.selection_type === "pick_product_price") {
              displayPickProductPrice = true;
            }

            newValues.push(newData2);
          }
          newData[key] = newValues;
        }
      }
      this.refreshArraySelector(newData, i);
      arraySelector.push(newData);
    }

    if (displayPickProductPrice) {
      price = 0.0;
      this.setState({ counter: 0 });
    }

    this.setState({
      arraySelector,
      insideTimeBased,
      title,
      subTitle,
      price,
      displayOnly,
      pairedUser,
      unpairedAvailable: productItem.unpaired_available,
      displayPickProductPrice: displayPickProductPrice,
      fulfillmentTypeName: get(dataParent, "store.fulfillment_type_name"),
    });
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    let { product } = this.state;
    if (!product) {
      const { productId } = this.props.match.params;
      const language = this.props.i18n.language;

      getMainData(productId, language).then(
        function (property) {
          Property.setCurrencyCode(property.currency_code);
          Property.setData(property);
          product = Property.getProduct(productId);
          this.setState({
            product,
            fulfillmentTypeName: get(property, "store.fulfillment_type_name"),
          });

          // Set the navigation title for putting on next page title
          Property.clearPreviousTitle();
          Property.setPreviousTitle(get(property, "category.title", ""));
          Property.setWebStoreType({
            uid: get(property, "category.uid", ""),
            language: language,
            type: "category",
          });

          this.setDisplay();
        }.bind(this)
      );

      return;
    }

    const property = Property.getData();
    const configuration = Property.getConfiguration(property.uid);
    const enableInventoryManagement = get(
      configuration,
      "preset_config.enable_inventory_management",
      false
    );
    const fixedInventorySelection =
      find(get(product, "options", []), {
        selection_type: "fixed_inventory_selection",
      }) && enableInventoryManagement;
    const productHourlySelection =
      find(get(product, "options", []), { selection_type: "hourly_product" }) &&
      enableInventoryManagement;
    this.setState({
      fixedInventorySelection,
      configuration,
      fulfillmentTypeName: get(property, "store.fulfillment_type_name"),
    });
    if (enableInventoryManagement && fixedInventorySelection) {
      await this.handleFetchFixedInventoryAvailabilities();
      const maxQuantity = this.maxQuantityOrder();
      if (maxQuantity < this.state.counter && this.state.counter > 0) {
        this.setState({ counter: maxQuantity });
      } else if (maxQuantity >= 1 && this.state.counter === 0) {
        this.setState({ counter: 1 });
      }
    } else if (enableInventoryManagement && productHourlySelection) {
      const fromDate = moment().format("YYYYMMDD");
      const toDate = moment().add(30, "days").format("YYYYMMDD");
      await this.handleFetchAvailabilities(null, null, 1, fromDate, toDate);
      const inventoryDates = Array.from(
        new Set(
          get(this.state.inventory, "availabilities", []).map((item) =>
            moment(item["date"]).format("YYYY-MM-DD")
          )
        )
      ).map((dateString) => moment(dateString));
      const dailyProduct = get(
        this.state.inventory,
        "availabilities[0][date]",
        null
      );
      this.setState({
        dailyProduct,
        inventoryDates,
        loading: false,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
    this.setDisplay();
  }

  componentDidUpdate = () => {
    if (isEmpty(this.state.preset) && !isUndefined(Property.getPreset())) {
      const presets = Property.getPreset();
      setHomeGlobalBackgroundColor(presets);
      this.setState({ preset: presets });
    }
  };

  refreshArraySelector(data, id) {
    let value = 0;
    if (data && data.selection_type === "pick_one_price") {
      for (const i in data.values) {
        if (data.values[i].select === true) {
          value = data.values[i].price;
        }
      }
    }

    if (data && data.selection_type === "pick_multiple_price") {
      for (const i in data.values) {
        if (data.values[i].select === true) {
          value = value + data.values[i].price;
        }
      }
    }

    if (data && data.selection_type === "pick_product_price") {
      const items = filter(data.values, function (o) {
        return o.value > 0;
      });
      value += sumBy(items, (data) => {
        return data.value * data.price;
      });
      const counter = sumBy(items, (data) => {
        return data.value;
      });
      this.setState({ counter: counter });
    }

    const pickPricesClone = this.state.addedPrice;

    pickPricesClone[id] = value;
    this.setState({
      addedPrice: pickPricesClone,
    });
  }

  renderTextAlert(preset) {
    const { displayOnly } = this.state;
    if (!isNull(Property.getAccessToken())) {
      if (displayOnly) {
        return (
          <TitleAlert
            className={"instructionTitle"}
            app_home_list_item_subtitle_color={
              preset.app_home_list_item_subtitle_color
            }>
            {this.props.t("THIS_ITEM_IS_FOR_DISPLAY")}
          </TitleAlert>
        );
      } else if (
        !isNull(Property.getPairGuest()) &&
        !Property.getPairGuest() &&
        !Property.getProductAvailableForUnpair()
      ) {
        return (
          <TitleAlert
            className={"instructionTitle"}
            app_home_list_item_subtitle_color={
              preset.app_home_list_item_subtitle_color
            }>
            Please pair to the room to place an order
          </TitleAlert>
        );
      } else if (!this.state.insideTimeBased.insideTimeBased) {
        return (
          <TitleAlert
            className={"instructionTitle"}
            app_home_list_item_subtitle_color={
              preset.app_home_list_item_subtitle_color
            }>
            {this.state.insideTimeBased.displayText}
          </TitleAlert>
        );
      }
    } else if (!this.state.insideTimeBased.insideTimeBased) {
      return (
        <TitleAlert
          className={"instructionTitle"}
          app_home_list_item_subtitle_color={
            preset.app_home_list_item_subtitle_color
          }>
          {this.state.insideTimeBased.displayText}
        </TitleAlert>
      );
    } else {
      return null;
    }
  }

  handleHourlyProductSelect = async ({ date, timeframe }) => {
    const cartItem = Property.getCartItem();
    let sum = parseInt(this.state.counter);
    const productId = this.state.product && this.state.product.uid;
    for (const item of cartItem) {
      let hourlyProductValues = find(get(item, "selection_options", []), {
        type: "hourly_product",
      });
      if (hourlyProductValues && productId === get(item, "uid")) {
        if (item.item_quantity) sum += parseInt(item.item_quantity);
      }
    }
    await this.handleFetchAvailabilities(date, timeframe, sum);
    this.handleAvailabilityPopup();
  };
  handleFetchAvailabilities = async (
    date,
    timeframe,
    quantity,
    fromDate = null,
    toDate = null
  ) => {
    const accessToken = await this.getAccessToken(Property.getUid());
    const productId = this.state.product && this.state.product.uid;
    await this.getInventory(
      accessToken.access_token,
      productId,
      fromDate || date,
      toDate || date,
      timeframe,
      quantity
    );
  };
  handleFixedInventorySelect = async () => {
    this.handleAvailabilityPopup();
    const accessToken = await this.getAccessToken(Property.getUid());
    const productId = this.state.product && this.state.product.uid;
    this.getFixedInventory(accessToken, productId, Property.getUid());
  };
  handleFetchFixedInventoryAvailabilities = async () => {
    const accessToken = await this.getAccessToken(Property.getUid());
    const productId = this.state.product && this.state.product.uid;
    await this.getFixedInventory(accessToken.access_token, productId);
  };
  handleAvailabilityPopup = () => {
    this.setState({
      enableAvailabilityPopup: true,
    });
  };
  handleAvailabilityClosePopup = () => {
    this.setState({
      enableAvailabilityPopup: false,
    });
  };
  handleAvailabilitySelect = async ({ e, inventory, date }) => {
    const arraySelector = this.state.arraySelector.map((item) => {
      if (item.selection_type === "hourly_product") {
        const value = find(item.values, { id: inventory.timeslot_id });
        value.date = date;
        value.select = true;
        item.values = [value];
      }
      return item;
    });
    this.setState({
      arraySelector: arraySelector,
    });
    this.navbarClicked(e);
  };

  handleFixedInventoryAvailabilitySelect = async (e) => {
    const date = moment().format("YYYYMMDD");
    const arraySelector = this.state.arraySelector.map((item) => {
      if (item.selection_type === "fixed_inventory_selection") {
        const value = {
          date,
          id: item.id,
          select: true,
          counter: this.state.counter,
        };
        item.values = [value];
      }
      return item;
    });
    this.setState({
      arraySelector,
    });
    this.navbarClicked(e);
  };

  async getAccessToken(propertyUid) {
    const response = await TokenService.getProperty(propertyUid);
    return response.data;
  }

  async getInventory(accessToken, productId, from, to, timeframe, quantity) {
    const response = await InventoryService.getAvailability(
      accessToken,
      productId,
      from,
      to,
      timeframe,
      quantity
    );
    let timeframeData;
    let timeframeRange;
    if (response.data) {
      timeframeData = find(response.data.timeframes, { timeframe: timeframe });
      timeframeRange =
        timeframeData &&
        `${timeframeData.start_time} - ${timeframeData.end_time}`;
    }
    const dailyProduct = get(response.data, "availabilities[0][date]", from);
    this.setState({
      dailyProduct,
      timeframe,
      timeframeRange,
      inventory: response.data,
    });
  }

  async getFixedInventory(accessToken, productId, propertyUid) {
    const response = await FixedInventoryService.getAvailability(
      accessToken,
      productId,
      propertyUid
    );
    const soldOut =
      response.data &&
      get(response.data, "availabilities.available_quantity", 0) === 0;
    this.setState({
      soldOut,
      loading: false,
      fixedInventory: response.data,
    });
  }

  maxQuantityOrder = () => {
    const { fixedInventorySelection, product, fixedInventory } = this.state;
    let itemQuantity = 0;
    let maxQuantity = get(product, "max_quantity", 0);
    if (fixedInventorySelection) {
      let cartItem = Property.getCartItem();
      for (const item of cartItem) {
        if (item.uid === product.uid) {
          itemQuantity += item.item_quantity;
        }
      }
      const totalQuantity = get(
        fixedInventory,
        "availabilities.available_quantity",
        0
      );

      if (fixedInventorySelection) {
        const maxOrder = get(
          fixedInventory,
          "availabilities.max_quantity",
          get(product, "max_quantity", 0)
        );
        if (maxOrder > totalQuantity) {
          maxQuantity = totalQuantity;
        } else {
          maxQuantity = maxOrder;
        }
      }
    }
    return maxQuantity - itemQuantity;
  };

  render() {
    const {
      displayPickProductPrice,
      preset,
      inventory,
      dailyProduct,
      timeframe,
      enableHourlyPopup,
      enableAvailabilityPopup,
      timeframeRange,
      fixedInventorySelection,
      fixedInventory,
      soldOut,
      loading,
      product,
    } = this.state;
    const location = this.props.location;
    const productUrl =
      location && location.fromProductList ? location.fromProductList.url : "";
    const imageProduct = product ? product.image : null;
    const title = this.state.title;
    const subTitle = this.state.subTitle;
    let price = this.state.price;
    let priceWithoutAddition = this.state.price;
    for (const i in this.state.addedPrice) {
      price = price + this.state.addedPrice[i];
    }
    const priceProduct = price * this.state.counter;
    const currencyCode = Property.getCurrencyCode();
    const basketText =
      this.state.fulfillmentTypeName !== "club_events"
        ? "TO_BASKET"
        : "CLUB_EVENT_TICKETS";
    const bottomText = `${this.props.t("ADD")} ${
      this.state.counter
    } ${this.props.t(basketText)} ${Intl.NumberFormat(currencyCode, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "code",
    }).format(displayPickProductPrice ? price : priceProduct)}`;
    const prevTitle = Property.getPreviousTitle();
    const displayOnly = this.state.displayOnly;
    const { categoryId } = this.props.match.params;
    const excludeOptions = ["hourly_product", "fixed_inventory_selection"];
    return (
      <div>
        <TopBar
          title={""}
          previousUrl={`/categories/${categoryId}/products`}
          previousTitle={prevTitle ? prevTitle : undefined}
          currentPage={"productDetail"}
        />
        {!this.state.product || loading ? (
          <>
            <div
              style={{
                display: "flex",
                height: "100vh",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <LoadingIcon loadingState={true} />
            </div>
          </>
        ) : (
          <>
            <TopPadding className="lg:hidden" />
            <div className={"sectionContent"}>
              <HeaderImage
                image={imageProduct}
                preset={preset}
                placeholderRectangle={placeholderRectangle}
                breakpointWidth={768}
                breakpointHeight={400}
              />
              {this.state.requiredField ? (
                <FillRequiredModal
                  stateModal={this.state.requiredField}
                  openCloseModal={(stateModal) =>
                    this.setState({ requiredField: stateModal })
                  }
                />
              ) : null}
              <Container className={"sectionContentLandscape"}>
                <ListTitle>
                  <ListHeaderTitle
                    app_home_list_item_title_color={
                      preset.app_home_list_item_title_color
                    }
                    className={"title"}>
                    {Property.getTitleCapital(title.toLowerCase())}
                  </ListHeaderTitle>
                  <ListSubTitle
                    className={"subtitle"}
                    app_home_list_item_subtitle_color={
                      preset.app_home_list_item_subtitle_color
                    }>
                    {replace(subTitle, "{chat}", "")}
                  </ListSubTitle>
                  <div style={{ textAlign: "center" }}>
                    {!displayPickProductPrice &&
                      priceWithoutAddition !== 0.0 && (
                        <TitlePrice className={"priceTitle"}>
                          {Intl.NumberFormat(currencyCode, {
                            style: "currency",
                            currency: currencyCode,
                            currencyDisplay: "code",
                          }).format(priceWithoutAddition)}
                        </TitlePrice>
                      )}
                    {this.renderTextAlert(preset)}
                  </div>
                </ListTitle>
                <div style={{ marginTop: -16, marginBottom: 50 }} />
                {!isNull(Property.getPairGuest()) &&
                  !Property.getPairGuest() &&
                  !Property.getProductAvailableForUnpair() && (
                    <div style={{ textAlign: "center" }}>
                      <PairButton
                        id={"web_view_pair_button"}
                        className={"textStyle"}
                        onClick={this.handleClickPairButton}
                        app_home_text_top_nav={preset.text_color}
                        app_home_color_primary={preset.app_home_color_primary}>
                        {!isNull(Property.getSignIn()) && Property.getSignIn()
                          ? this.props.t("PLEASE_PAIR")
                          : this.props.t("SIGN_IN_NOW")}
                      </PairButton>
                    </div>
                  )}
                {displayOnly && (
                  <Flex
                    container
                    flex={1}
                    margin={"0"}
                    justifyContent={"center"}>
                    <ListSubTitle
                      className={"subtitle m-0 p-0"}
                      app_home_list_item_subtitle_color={
                        preset.app_home_list_item_subtitle_color
                      }>
                      {this.props.t("THIS_ITEM_IS_FOR_DISPLAY")}
                    </ListSubTitle>
                  </Flex>
                )}

                {displayOnly ||
                !this.state.insideTimeBased.insideTimeBased ||
                (!isNull(Property.getPairGuest()) &&
                  !Property.getPairGuest() &&
                  !Property.getProductAvailableForUnpair()) ? null : (
                  <>
                    {fixedInventorySelection && displayPickProductPrice && (
                      <Flex
                        container
                        flex={1}
                        margin={"0"}
                        justifyContent={"center"}>
                        <ListSubTitle
                          className={"subtitle m-0 p-0"}
                          app_home_list_item_subtitle_color={
                            preset.app_home_list_item_subtitle_color
                          }>
                          {soldOut ? (
                            this.props.t("SOLD_OUT")
                          ) : (
                            <>
                              {`${get(
                                fixedInventory,
                                "availabilities.available_quantity",
                                0
                              )} ${this.props.t("LEFT_IN_STOCK")}.`}
                              <br />
                              {`${this.props.t(
                                "MAX_ORDER"
                              )}: ${this.maxQuantityOrder()}`}
                            </>
                          )}
                        </ListSubTitle>
                      </Flex>
                    )}
                    {(!fixedInventorySelection ||
                      (fixedInventorySelection && !soldOut)) &&
                      this.state.arraySelector.map((item, index) => {
                        return excludeOptions.includes(item.selection_type) ? (
                          ""
                        ) : (
                          <Flex
                            container
                            flex={1}
                            margin={"16px 0"}
                            key={index}>
                            <Selector
                              selectionType={item.selection_type}
                              item={{
                                ...item,
                                minBookingNoticeDays:
                                  this.state.product?.min_booking_notice_days,
                              }}
                              index={index}
                              onChange={(event) => {
                                let arraySelector = this.state.arraySelector;
                                arraySelector[index].values =
                                  event.target.value;
                                this.setState({ arraySelector });
                              }}
                              refreshData={(data, id) =>
                                this.refreshArraySelector(data, id)
                              }
                              checkValidation={this.state.checkValidation}
                            />
                          </Flex>
                        );
                      })}
                  </>
                )}
                {displayOnly ||
                !this.state.insideTimeBased.insideTimeBased ||
                displayPickProductPrice ||
                (!isNull(Property.getPairGuest()) &&
                  !Property.getPairGuest() &&
                  !Property.getProductAvailableForUnpair()) ? null : (
                  <>
                    {fixedInventorySelection && (
                      <Flex
                        container
                        flex={1}
                        margin={"0"}
                        justifyContent={"center"}>
                        <ListSubTitle
                          className={"subtitle m-0 p-0"}
                          app_home_list_item_subtitle_color={
                            preset.app_home_list_item_subtitle_color
                          }>
                          {soldOut ? (
                            this.props.t("SOLD_OUT")
                          ) : (
                            <>
                              {`${get(
                                fixedInventory,
                                "availabilities.available_quantity",
                                0
                              )} ${this.props.t("LEFT_IN_STOCK")}`}
                              <br />
                              {`${this.props.t(
                                "MAX_ORDER"
                              )}: ${this.maxQuantityOrder()}`}
                            </>
                          )}
                        </ListSubTitle>
                      </Flex>
                    )}
                    {(!fixedInventorySelection ||
                      (fixedInventorySelection && !soldOut)) && (
                      <Flex
                        container
                        flex={1}
                        margin={"16px 0"}
                        justifyContent={"center"}>
                        <CircleButton
                          app_home_color_secondary={
                            preset.app_home_color_secondary
                          }>
                          <div onClick={() => this.plusMinus("minus")}>
                            <RemoveCircle style={{ fontSize: 35 }} />
                          </div>
                          <NumberStyle>{this.state.counter}</NumberStyle>
                          <div onClick={() => this.plusMinus("plus")}>
                            <AddCircle style={{ fontSize: 35 }} />
                          </div>
                        </CircleButton>
                      </Flex>
                    )}
                  </>
                )}
                {this.bottomBar(productUrl, bottomText)}
              </Container>
            </div>
          </>
        )}

        {enableHourlyPopup && (
          <HourlyProduct
            showPopup={enableHourlyPopup}
            modalTitle={this.props.t("WHEN")}
            dates={this.state.inventoryDates}
            primaryColor={preset.app_home_color_primary}
            appHomeTextCallToAction={preset.text_color}
            buttonStyleName={preset.buttonStyleName}
            getDate={dailyProduct}
            getTimeframe={timeframe}
            onSelect={this.handleHourlyProductSelect}
            onCancel={this.hourlyProductClosePopup}
            t={this.props.t}
          />
        )}
        {enableAvailabilityPopup && (
          <Availability
            showPopup
            modalTitle={this.props.t("WHEN")}
            eventName={this.state.product.title}
            getInventory={inventory}
            getAvailabilities={inventory && inventory.availabilities}
            dates={this.state.inventoryDates}
            getDate={dailyProduct}
            getTime={timeframeRange}
            getTimeframe={timeframe}
            primaryColor={preset.app_home_color_primary}
            appHomeTextCallToAction={preset.text_color}
            buttonStyleName={preset.buttonStyleName}
            onSelect={this.handleAvailabilitySelect}
            onCancel={this.handleAvailabilityClosePopup}
            onback={this.hourlyProductPopup}
            onFetchAvailabilities={this.handleHourlyProductSelect}
            t={this.props.t}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(ProductDetail);
